var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-background-white" }, [
    _c("div", { staticClass: "o-width-limiter" }, [
      _c(
        "div",
        {
          staticClass:
            "c-buffer-box c-buffer-box--no-top c-buffer-box--tight-bottom d-print-none"
        },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _vm._v("Tillbaka till alla processer")
          ]),
          _vm._v(" "),
          _vm.appCustomerLogotype
            ? _c("img", {
                staticClass: "customer-image t-margin-bottom-s",
                attrs: {
                  src: _vm.appCustomerLogotype,
                  alt: "",
                  width: "200",
                  height: "50"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "o-grid" }, [
        _c(
          "div",
          {
            staticClass: "o-grid__column t-hidden@below-md",
            attrs: { "data-size": "md:3" }
          },
          [
            _vm.id !== "0"
              ? _c("process-steps-data-provider", {
                  attrs: { "process-id": _vm.currentId },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(dataProvider) {
                          return _c(
                            "div",
                            {},
                            [
                              _c("process-step-summary", {
                                attrs: {
                                  "process-name": dataProvider.processName,
                                  "process-steps": dataProvider.processSteps
                                }
                              })
                            ],
                            1
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    1312600620
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "o-grid__column o-grid__column--block t-position-relative",
            attrs: { id: "content-primary", "data-size": "below-md:12 md:9" }
          },
          [
            _c("process-data-provider", {
              ref: "refDataProvider",
              attrs: {
                "process-id": _vm.id,
                "original-id": _vm.originalId,
                category: _vm.category
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(dataProvider) {
                    return _c(
                      "div",
                      {},
                      [
                        dataProvider.hasChangelogReminder
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-message c-message--inline c-message--narrow t-margin-bottom-m"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-message__inner" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "c-message__text" },
                                        [
                                          _c("p", [_vm._v("Ändringshistorik")]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-message__body-text"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Kom ihåg att lägga till en kommentar i\n                      ändringshistoriken vid ändringar.\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "c-button c-button--reset c-message__close",
                                          attrs: { title: "Stäng" },
                                          on: {
                                            click: function($event) {
                                              return dataProvider.removeProcessIdRemindChangelog(
                                                { id: _vm.id }
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("vue-icon", {
                                            attrs: { name: "close" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "t-visually-hidden"
                                            },
                                            [_vm._v("Stäng")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        dataProvider.error > 0
                          ? [
                              _c("h1", { staticClass: "t-text-style-alpha" }, [
                                _vm._v("Processen kunde inte hittas")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "t-margin-top-s" }, [
                                _vm._v(
                                  "\n                Det finns inte någon process med id\n                "
                                ),
                                _c("span", { staticClass: "t-style-italic" }, [
                                  _vm._v(_vm._s(_vm.id))
                                ]),
                                _vm._v(
                                  ", eller så saknar du behörighet att se den.\n              "
                                )
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        dataProvider.error === 0
                          ? [
                              dataProvider.loading
                                ? _c("div", { staticClass: "c-spinner" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "vue-tabs",
                                {
                                  attrs: {
                                    show:
                                      _vm.$can(
                                        "customize",
                                        "ProcessTemplate"
                                      ) &&
                                      dataProvider.originalProcess &&
                                      Object.keys(dataProvider.originalProcess)
                                        .length > 0,
                                    process: dataProvider.process
                                  },
                                  on: {
                                    open: _vm.openChangeLog,
                                    markasread: _vm.markRead,
                                    tabSwitched: function($event) {
                                      _vm.tabSwitched($event)
                                      dataProvider.tabSwitched($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "Process" },
                                    [
                                      _c(
                                        "process-item",
                                        _vm._b(
                                          {
                                            attrs: {
                                              mode: dataProvider.mode,
                                              error: dataProvider.error,
                                              category: dataProvider.category
                                            },
                                            on: {
                                              edit: dataProvider.edit,
                                              create: dataProvider.create,
                                              publish: dataProvider.publish,
                                              unpublish: dataProvider.unpublish,
                                              customize: dataProvider.customize,
                                              delete: dataProvider.delete
                                            }
                                          },
                                          "process-item",
                                          dataProvider.process,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "Processmall" },
                                    [
                                      _c(
                                        "process-item",
                                        _vm._b(
                                          {
                                            attrs: {
                                              mode: "view",
                                              error: dataProvider.error,
                                              expandChangeLogFromStart:
                                                dataProvider.process &&
                                                dataProvider.process
                                                  .notifications &&
                                                dataProvider.process
                                                  .notifications.length > 0,
                                              showConsentButton:
                                                dataProvider.process &&
                                                dataProvider.process
                                                  .notifications &&
                                                dataProvider.process
                                                  .notifications.length > 0
                                            },
                                            on: {
                                              edit: dataProvider.edit,
                                              customize: dataProvider.customize,
                                              logReadConsent: _vm.logReadConsent
                                            }
                                          },
                                          "process-item",
                                          dataProvider.originalProcess,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "notify" },
                                    [
                                      dataProvider.process &&
                                      dataProvider.process.notifications &&
                                      dataProvider.process.notifications
                                        .length > 0
                                        ? _c("notify-pill", {
                                            attrs: {
                                              notifications:
                                                dataProvider.process
                                                  .notifications
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }